export default "__VITE_ASSET__b52afd16__"